import React, {useEffect, useRef, useState} from 'react';
import vars from '../../utils/vars';
import classNames from "classnames";
import PropTypes from 'prop-types';
import './IconButton.scss';

const DEFAULT_FILL = vars['color_icon_default'];

export default function IconButton(props) {
	const IconComponent = props.IconComponent;
	const svgRef = useRef(null);
	const [fill, setColor] = useState(DEFAULT_FILL);
	const [boxSize, setBoxSize] = useState(props.boxSize || props.width | props.height || false);
	const [width, setWidth] = useState();
	const [height, setHeight] = useState();
	const [viewBoxBaseVal, setViewBoxBaseVal] = useState(svgRef?.current?.viewBox?.baseVal);

	const getBoxStyles = () => {
		return Number.isFinite(props.boxSize)
			? {
				width: boxSize,
				height: boxSize,
				minWidth: boxSize,
				minHeight: boxSize,
			}
			: {};
	};

	const getIconStyles = () => {
		const {width: vbWidth = 20, height: vbHeight = 20} = (viewBoxBaseVal || {});
		let res = {};

		if (width) {
			res = {
				width: width ? width : boxSize,
				height: vbWidth / vbHeight * width,
			}
		} else if (height) {
			res = {
				width: vbWidth / vbHeight * height,
				height: height ? height : boxSize,
			}
		} else if (viewBoxBaseVal) {
			res = {
				width: vbWidth,
				height: vbHeight,
			};
		}
		return res;
	};

	useEffect(() => {
		props.width && setWidth(props.width);
		props.height && setHeight(props.height);
		props.boxSize && setBoxSize(props.boxSize);
		props.fill && setColor(props.fill);
		setViewBoxBaseVal(svgRef?.current?.viewBox?.baseVal);
	}, [props]);

	return (
		<span
			className={classNames(['iconButton-container', IconComponent?.render?.name])}
			style={getBoxStyles(boxSize)}
		>
			<IconComponent
				ref={svgRef}
				className="iconButton-svg"
				fill={fill}
				{...getIconStyles()}
			/>
		</span>
	)
}

export const IconButtonPropTypes = PropTypes.shape({
	IconComponent: PropTypes.elementType.isRequired,
	fill: PropTypes.string,
	boxSize: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
});

IconButton.propTypes = IconButtonPropTypes.isRequired;